<template>
  <div>
    <!-- 本年入学学生统计 -->
    <Echart :options="options" height="350px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
import echarts from 'echarts';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    LBdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    LBdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          // 距离dom四周的距离
          grid: {
            top: '20%',
            left: '10%',
            right: '10%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: newData.xAxisData,
              axisLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0.12)'
                }
              },
              axisLabel: {
                margin: 10,
                color: '#e2e9ff',
                textStyle: {
                  fontSize: 14
                }
              }
            }
          ],
          yAxis: [
            {
              name: '单位：人',
              axisLabel: {
                formatter: '{value}',
                color: '#e2e9ff'
              },
              axisLine: {
                show: false
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0.12)'
                }
              }
            }
          ],
          series: [
            {
              type: 'bar',
              data: newData.seriesData,
              barWidth: '20px',
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: 'rgba(0,244,255,1)' // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: 'rgba(0,77,167,1)' // 100% 处的颜色
                      }
                    ],
                    false
                  ),
                  barBorderRadius: [30, 30, 30, 30],
                  shadowColor: 'rgba(0,160,221,1)',
                  shadowBlur: 4
                }
              },
              label: {
                normal: {
                  show: true,
                  lineHeight: 30,
                  width: 80,
                  height: 30,
                  backgroundColor: 'rgba(0,160,221,0.1)',
                  borderRadius: 200,
                  position: ['-8', '-60'],
                  distance: 1,
                  formatter: ['    {d|●}', ' {a|{c}}     \n', '    {b|}'].join(
                    ','
                  ),
                  rich: {
                    d: {
                      color: '#3CDDCF'
                    },
                    a: {
                      color: '#fff',
                      align: 'center'
                    },
                    b: {
                      width: 1,
                      height: 30,
                      borderWidth: 1,
                      borderColor: '#234e6c',
                      align: 'left'
                    }
                  }
                }
              }
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
